export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            REGISTERED: 'REGISTERED',
            IN_PROGRESS: 'IN_PROGRESS',
            PASSED: 'PASSED',
            NOT_PASSED: 'NOT_PASSED',
            NOT_PASSED_CAN_RETAKE: 'NOT_PASSED_CAN_RETAKE',
            IN_ASSESSMENT: 'IN_ASSESSMENT'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('course.trainingStatusType.NotStarted'),
            REGISTERED: $translate.instant('course.trainingStatusType.Registered'),
            IN_PROGRESS: $translate.instant('course.trainingStatusType.InProgress'),
            PASSED: $translate.instant('course.trainingStatusType.Passed'),
            NOT_PASSED: $translate.instant('course.trainingStatusType.NotPassed'),
            NOT_PASSED_CAN_RETAKE: $translate.instant('course.trainingStatusType.NotPassedCanRetake'),
            IN_ASSESSMENT: $translate.instant('validations.In validation')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingStatusType/index.js